import { z } from 'zod';

/////////////////////////////////////////
// NOTIFY CONTENT TO NOTIFY SUBSCRIPTION GROUP SCHEMA
/////////////////////////////////////////

export const NotifyContentToNotifySubscriptionGroupSchema = z.object({
  notifyContentId: z.number().int(),
  notifySubscriptionGroupId: z.number().int(),
  rowTimestamp: z.coerce.date(),
})

export type NotifyContentToNotifySubscriptionGroup = z.infer<typeof NotifyContentToNotifySubscriptionGroupSchema>

export default NotifyContentToNotifySubscriptionGroupSchema;
